(function() { window.GUID_922d3c4b_07a6_4635_9eb0_52cc37687ab3 = { getGuid: function() { return "922d3c4b-07a6-4635-9eb0-52cc37687ab3"; } }; })();
var CS;
(function (CS) {
    class UserDisclaimer {
        static CheckIfAnyDisclaimer(jqXHR) {
            let show = jqXHR.getResponseHeader("userdisclaimertoshow");
            if (show) {
                let context = $('#user-disclaimer-container').data('context');
                context.ShowDisclaimer();
            }
        }
        ShowDisclaimer() {
            //Test, si IFrame, on ne fait rien
            if (window.self !== window.top)
                return;
            let operid = null;
            let me = this;
            if ($('#CurrentOperator').length > 0) {
                var ctl = $('#CurrentOperator').control();
                if (ctl != undefined) {
                    operid = ctl.GetSelectedItemValue('id');
                }
            }
            let assocId = null;
            if ($('#SelectedAssociationId').length > 0) {
                var ctl = $('#SelectedAssociationId').control();
                if (ctl != undefined) {
                    assocId = ctl.GetSelectedItemValue('value');
                }
            }
            if (assocId == null) {
                if ($('#AssociationId').length > 0) {
                    assocId = $('#AssociationId').val();
                }
            }
            let data = {
                operatorId: operid,
                assocId: assocId,
                associationId: assocId
            };
            CompuSport.Ajax.Get("/Global/GetUserDisclaimer/" + CSParameters.SportEventId, data, function (response) {
                me.fillContent(response);
            });
        }
        handleBehavior() {
            let me = this;
            let $userDisclaimerContainer = $('#user-disclaimer-container');
            if ($userDisclaimerContainer.hasClass('show')) {
                me.ShowDisclaimer();
                return;
            }
        }
        fillContent(newContent) {
            if (newContent) {
                let me = this;
                let $userDisclaimerContainer = $('#user-disclaimer-container');
                $userDisclaimerContainer.empty();
                $userDisclaimerContainer.append(newContent);
                $userDisclaimerContainer.on('click', 'button', function () {
                    me.updateDisclaimer($(this));
                });
                $userDisclaimerContainer.slideDown();
            }
        }
        updateDisclaimer($clickedButton) {
            let me = this;
            let $userDisclaimer = $('#user-disclaimer');
            let data = {
                userRowId: $userDisclaimer.data('userrowid'),
                operatorId: $userDisclaimer.data('operatorid'),
                associationDisclaimerSeasonId: $userDisclaimer.data('associationdisclaimerseasonid'),
                status: $clickedButton.data('value')
            };
            CompuSport.Ajax.Post("/Global/UpdateUserDisclaimer", data, function (response) {
                let $userDisclaimerContainer = $('#user-disclaimer-container');
                $userDisclaimerContainer.slideUp();
                //me.fillContent(response);
            });
        }
    }
    CS.UserDisclaimer = UserDisclaimer;
    let instance = new UserDisclaimer();
    $('#user-disclaimer-container').data('context', instance);
    instance.handleBehavior();
})(CS || (CS = {}));

//# sourceMappingURL=UserDisclaimer.js.map
